import { AccountStatus } from '@percent/domain/iam'
import type { Account, AssigneeSearchResult } from '@percent/domain/iam'
import type { Group } from '@percent/admin-dashboard/api/actions/groups/groups.types'

export const toAssigneeSearchResults = (accounts: Account[], groups: Group[]): AssigneeSearchResult[] => [
  ...accounts
    // Removed accounts can't be assigned roles (the API 404s)
    .filter(account => account.status !== AccountStatus.removed)
    .map(account => ({ type: 'account' as const, id: account.id, name: account.fullName || account.email })),
  ...groups.map(group => ({ type: 'group' as const, id: group.id, name: group.name }))
]
